import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import type LoggingService from '@linc-technologies/linced-common/services/logging';

interface ApiError {
  errors?: { status?: string; detail?: string }[];
  message?: string;
}

export default class BaseRoute<Model = unknown> extends Route<Model> {
  @service
  declare logging: LoggingService;

  @action
  error(error: ApiError, transition: Transition) {
    this.logging.pushError(error, 'route:error', {
      transitionFrom: transition.from ? transition.from.name : 'unknown',
      transitionTo: transition.to ? transition.to.name : 'unknown',
      code: error.errors?.[0]?.status ?? 'unknown',
      detail: error.errors?.[0]?.detail ?? 'unknown',
      message: error.message ? error.message : '',
    });
    return true;
  }
}
